import React from 'react';
import AppLayouts from './AppLayouts';
import Routes from '../../app/routes';
import { useSelector } from 'react-redux';

import { LicenseInfo } from '@mui/x-license-pro';

const AppLayout = () => {
  LicenseInfo.setLicenseKey(
    '038b5d9724b7b946e284c5c8d7034463Tz0xMzMzMDksRT0xODIxODMwMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI='
  );

  const horizontalNavPosition = useSelector(
    ({ settings }) => settings.horizontalNavPosition
  );
  const navigationStyle = useSelector(
    ({ settings }) => settings.navigationStyle
  );
  const onGetLayout = (layout) => {
    switch (layout) {
      case 'inside_the_header':
        return 'InsideHeaderNav';

      case 'above_the_header':
        return 'AboveHeaderNav';

      case 'below_the_header':
        return 'BelowHeaderNav';
      default:
        return 'Vertical';
    }
  };

  const Layout =
    AppLayouts[
      navigationStyle === 'vertical_navigation'
        ? 'Vertical'
        : onGetLayout(horizontalNavPosition)
    ];
  return (
    <Layout>
      <Routes />
    </Layout>
  );
};

export default AppLayout;
